import type { ERFilterKey } from '~/presentation/reports/common/type';

import { FILTER_SETTING_UI } from '~/presentation/reports/common/ReportFilter/constants/report-filters';

export function getFilterSettingUIs(data: ERFilterKey[]) {
  return data.map((key) => FILTER_SETTING_UI[key]);
}
